// Use the following code to set the base URL when performing local development/testing:
//
// if (typeof Samcart === 'undefined') {
//     Samcart = {};
// }
// Samcart.domain = [desired domain ending in a slash]

//Init
if (typeof Samcart === 'undefined') {
    Samcart = {};
}
Samcart.Embed = {};
Samcart.Embed.eventRenderedComponents = {};
Samcart.componentModules = {};

Samcart.Embed.resetStyle =
    'animation : none;' +
    'animation-delay : 0 !important ;' +
    'animation-direction : normal !important ;' +
    'animation-duration : 0 !important ;' +
    'animation-fill-mode : none !important ;' +
    'animation-iteration-count : 1 !important ;' +
    'animation-name : none !important ;' +
    'animation-play-state : running !important ;' +
    'animation-timing-function : ease !important ;' +
    'backface-visibility : visible !important ;' +
    'background : 0 !important ;' +
    'background-attachment : scroll !important ;' +
    'background-clip : border-box !important ;' +
    'background-color : transparent !important ;' +
    'background-image : none !important ;' +
    'background-origin : padding-box !important ;' +
    'background-position : 0 0 !important ;' +
    'background-position-x : 0 !important ;' +
    'background-position-y : 0 !important ;' +
    'background-repeat : repeat !important ;' +
    'background-size : auto auto !important ;' +
    'border : 0 !important ;' +
    'border-style : none !important ;' +
    'border-width : medium !important ;' +
    'border-color : inherit !important ;' +
    'border-bottom : 0 !important ;' +
    'border-bottom-color : inherit !important ;' +
    'border-bottom-left-radius : 0 !important ;' +
    'border-bottom-right-radius : 0 !important ;' +
    'border-bottom-style : none !important ;' +
    'border-bottom-width : medium !important ;' +
    'border-collapse : separate !important ;' +
    'border-image : none !important ;' +
    'border-left : 0 !important ;' +
    'border-left-color : inherit !important ;' +
    'border-left-style : none !important ;' +
    'border-left-width : medium !important ;' +
    'border-radius : 0 !important ;' +
    'border-right : 0 !important ;' +
    'border-right-color : inherit !important ;' +
    'border-right-style : none !important ;' +
    'border-right-width : medium !important ;' +
    'border-spacing : 0 !important ;' +
    'border-top : 0 !important ;' +
    'border-top-color : inherit !important ;' +
    'border-top-left-radius : 0 !important ;' +
    'border-top-right-radius : 0 !important ;' +
    'border-top-style : none !important ;' +
    'border-top-width : medium !important ;' +
    'bottom : auto !important ;' +
    'box-shadow : none !important ;' +
    'box-sizing : content-box !important ;' +
    'caption-side : top !important ;' +
    'clear : none !important ;' +
    'clip : auto !important ;' +
    'color : inherit !important ;' +
    'columns : auto !important ;' +
    'column-count : auto !important ;' +
    'column-fill : balance !important ;' +
    'column-gap : normal !important ;' +
    'column-rule : medium none currentColor !important ;' +
    'column-rule-color : currentColor !important ;' +
    'column-rule-style : none !important ;' +
    'column-rule-width : none !important ;' +
    'column-span : 1 !important ;' +
    'column-width : auto !important ;' +
    'content : normal !important ;' +
    'counter-increment : none !important ;' +
    'counter-reset : none !important ;' +
    'cursor : auto !important ;' +
    'direction : ltr !important ;' +
    'display : inline !important ;' +
    'empty-cells : show !important ;' +
    'float : none !important ;' +
    'font : normal !important ;' +
    'font-family : inherit !important ;' +
    'font-size : medium !important ;' +
    'font-style : normal !important ;' +
    'font-variant : normal !important ;' +
    'font-weight : normal !important ;' +
    'height : auto !important ;' +
    'hyphens : none !important ;' +
    'left : auto !important ;' +
    'letter-spacing : normal !important ;' +
    'line-height : normal !important ;' +
    'list-style : none !important ;' +
    'list-style-image : none !important ;' +
    'list-style-position : outside !important ;' +
    'list-style-type : disc !important ;' +
    'margin : 0 !important ;' +
    'margin-bottom : 0 !important ;' +
    'margin-left : 0 !important ;' +
    'margin-right : 0 !important ;' +
    'margin-top : 0 !important ;' +
    'max-height : none !important ;' +
    'max-width : none !important ;' +
    'min-height : 0 !important ;' +
    'min-width : 0 !important ;' +
    'opacity : 1 !important ;' +
    'orphans : 0 !important ;' +
    'outline : 0 !important ;' +
    'outline-color : invert !important ;' +
    'outline-style : none !important ;' +
    'outline-width : medium !important ;' +
    'overflow : visible !important ;' +
    'overflow-x : visible !important ;' +
    'overflow-y : visible !important ;' +
    'padding : 0 !important ;' +
    'padding-bottom : 0 !important ;' +
    'padding-left : 0 !important ;' +
    'padding-right : 0 !important ;' +
    'padding-top : 0 !important ;' +
    'page-break-after : auto !important ;' +
    'page-break-before : auto !important ;' +
    'page-break-inside : auto !important ;' +
    'perspective : none !important ;' +
    'perspective-origin : 50% 50% !important ;' +
    'position : static !important ;' +
    'right : auto !important ;' +
    'tab-size : 8 !important ;' +
    'table-layout : auto !important ;' +
    'text-align : inherit !important ;' +
    'text-align-last : auto !important ;' +
    'text-decoration : none !important ;' +
    'text-decoration-color : inherit !important ;' +
    'text-decoration-line : none !important ;' +
    'text-decoration-style : solid !important ;' +
    'text-indent : 0 !important ;' +
    'text-shadow : none !important ;' +
    'text-transform : none !important ;' +
    'top : auto !important ;' +
    'transform : none !important ;' +
    'transform-style : flat !important ;' +
    'transition : none !important ;' +
    'transition-delay : 0s !important ;' +
    'transition-duration : 0s !important ;' +
    'transition-property : none !important ;' +
    'transition-timing-function : ease !important ;' +
    'unicode-bidi : normal !important ;' +
    'vertical-align : baseline !important ;' +
    'visibility : visible !important ;' +
    'white-space : normal !important ;' +
    'widows : 0 !important ;' +
    'width : auto !important ;' +
    'word-spacing : normal !important ;' +
    'z-index : auto !important ;';

Samcart.Embed.Core = {

    /**
     * Used by modules to register themselves
     * After a module is registered, an event is fired to process the module
     *
     * @param {string} name
     * @param {Object} module
     */
    registerModule: function registerModule(name, module) {
        Samcart.componentModules[name] = module;

        var event = new Event('Samcart_module_registered');
        event.module = module;
        document.dispatchEvent(event);
    },

    /**
     * Gets the base url based on the current env setting
     *
     * @returns {string}
     */
    getBaseUrl: function getBaseUrl() {
        return Samcart.domain ? Samcart.domain : 'https://samcart.com/';
    },

    /**
     *
     *
     * @param {string} tag
     * @param {object} component
     */
    registerEventRenderedComponent: function registerComponent(tag, component) {
        Samcart.Embed.eventRenderedComponents[tag] = component;
    },

    /**
     * Gets all elements with the sc-embed attribute
     *
     * @returns {Element}
     */
    getElements: function getElements() {
        return Array.prototype.slice.call(document.querySelectorAll("[sc-embed]"));
    },

    getComponent: function getComponent(tag, url) {
        if (typeof Samcart.Embed.eventRenderedComponents[tag] === 'function') {
            Samcart.Embed.eventRenderedComponents[tag] = Samcart.Embed.eventRenderedComponents[tag](tag, url);
        }

        return Samcart.Embed.eventRenderedComponents[tag];
    },

    /**
     * Creates and mounts a div element that will later be used to wrap the container
     *
     * @param ele
     * @returns {Element}
     */
    createComponentContainer: function createComopnentContainer(ele) {
        var container = document.createElement('div');

        //Preserve Samcart attributes from original element
        //incase future modules need to process the element
        //Example: one element could be used to generate a popup and buynow component
        for(var i = 0; i < ele.attributes.length; i++) {
            var attr = ele.attributes[i];
            if (attr.name.startsWith('sc-')) {
                container.setAttribute(attr.name, attr.value);
            }
        }

        //Get ele position in DOM
        var eleParent = ele.parentElement;
        var eleIndex = Array.prototype.indexOf.call(eleParent.childNodes, ele);
        container.style.cssText = Samcart.Embed.resetStyle;

        //Mount new container div
        eleParent.insertBefore(container, eleParent.childNodes[eleIndex]);

        return container;
    },
    /**
     * Removes the given element from the DOM. Used to remove anchor tags that have been replaced by a componenent
     *
     * @param {Element} ele
     */
    removeOriginalElement: function removeOriginalElement(ele) {
        var eleParent = ele.parentElement;
        eleParent.removeChild(ele);
    },

    /**
     * Renders the xcomponenet inside the given container element
     *
     * @param {Object} component
     * @param {Element} container
     */
    renderComponent: function renderComponent(component, container) {
        component.render({
            notifyClick: function (tag, url) {
                tag = tag.split('-').slice(0,-2).join('-') + '-click';
                var component = Samcart.Embed.Core.getComponent(tag, url);
                //Currently the only event based module is Popup. Popup doesn't require a container
                var containerElement = container;
                Samcart.Embed.Core.renderComponent(component, containerElement);
            },

            notifyRedirect: function(url) {
                window.location = url;
            }
        }, container)
    },

    registerClick: function registerClick(ele, tag, url) {
        ele.addEventListener('click', function(e) {
            e.preventDefault();
            var component = Samcart.Embed.Core.getComponent(tag, url);
            //Currently the only event based module is Popup. Popup doesn't require a container
            var containerElement = document.querySelector('body');
            Samcart.Embed.Core.renderComponent(component, containerElement);

        });

    },

    /**
     * Runs every time a module is registered.
     * Identifies elements that need processing by the module
     * and calls module functions to generate components.
     * Components are either immediately rendered or registered for rendering after some event (ex: click)
     *
     * @param {Event} e
     */
    execute: function execute(e) {
        var embedElements = [],
            embedElement = {},
            componentContainer = {},
            marketplaceToken = '',
            productSlug = '',
            tag = '',
            url = '',
            component = {},
            module = e.module,
            i = 0;

        embedElements = Samcart.Embed.Core.getElements();

        for(i; i < embedElements.length; i++) {
            embedElement = embedElements[i];
            marketplaceToken = embedElement.getAttribute('sc-marketplace') || embedElement.getAttribute('sc-button-marketplace');
            productSlug = embedElement.getAttribute('sc-product') || embedElement.getAttribute('sc-button-product');

            if (module.elementMatchesModule(embedElement)) {

                if (module.render_type ==='immediate') {
                    tag = module.generateTag(marketplaceToken, productSlug) + '-' + i;
                    component = module.createComponent(embedElement, tag);
                    componentContainer = Samcart.Embed.Core.createComponentContainer(embedElement);
                    Samcart.Embed.Core.removeOriginalElement(embedElement);
                    Samcart.Embed.Core.renderComponent(component, componentContainer);

                } else if (module.render_type === 'event') {
                    tag = module.generateTag(marketplaceToken, productSlug);
                    if (!Samcart.Embed.eventRenderedComponents.hasOwnProperty(tag)) {
                        // Component create function is stored.
                        // When a corresponding event is fired, the function will execute and resolve the component
                        component = module.createComponent;
                        Samcart.Embed.Core.registerEventRenderedComponent(tag, component);
                    }
                } else if (module.render_type === 'prerendered') {
                    tag = module.getTargetComponentTag(marketplaceToken, productSlug);
                    url = module.getTargetURL(embedElement);
                    Samcart.Embed.Core.registerClick(embedElement, tag, url);
                }
            }
        }
    }
};

document.addEventListener('Samcart_module_registered', Samcart.Embed.Core.execute);

//Example BuyNow embed code:
// <a href="https://boardswithholes.samcart.com/product/basic-plan"
// sc-embed="button"
// sc-product="basic-plan"
// sc-marketplace="boardswithholes"
// sc-button-background-color="#FB4F14">CREATE YOUR FIRST CHECKOUT PAGE FREE</a>
// <script>(function(d, s, id) {
//     var js, fjs = d.getElementsByTagName(s)[0];
//     if (d.getElementById(id)) return;
//     js = d.createElement(s); js.id = id;
//     js.src = "https://samcart.com/embed/embed.js";
//     fjs.parentNode.insertBefore(js, fjs);
// }(document, 'script', 'samcart-embed'));</script>

//Example Popup embed code:
// <a href="https://boardswithholes.samcart.com/product/basic-plan"
// sc-embed
// sc-popup
// sc-product="basic-plan"
// sc-marketplace="boardswithholes"
// sc-button-background-color="#FB4F14">CREATE YOUR FIRST CHECKOUT PAGE FREE</a>
// <script>(function(d, s, id) {
//     var js, fjs = d.getElementsByTagName(s)[0];
//     if (d.getElementById(id)) return;
//     js = d.createElement(s); js.id = id;
//     js.src = "https://samcart.com/modules/embed/embed.js";
//     fjs.parentNode.insertBefore(js, fjs);
// }(document, 'script', 'samcart-embed'));</script>

//Example PreRendered embed code
// <a href='https://testone.samcart.dev/products/asdf'
// sc-embed="custom"
// sc-product='asdf'
// sc-marketplace='0DhzNlosvZP9JIBhD8Sqzn6sY9WyHhRH'
// sc-popup>
// Buy Now
// </a>
// <script>
// (function(d, s, id) {var js, fjs = d.getElementsByTagName(s)[0];
//     if (d.getElementById(id)) return;
//     js = d.createElement(s); js.id = id;
//     js.src = 'https://samcart.dev/embed/embed.js';
//     fjs.parentNode.insertBefore(js, fjs);
// }(document, 'script', 'samcart-embed'));
// </script>
